module.exports = __webpack_public_path__ + "static/img/05049C_2_C_20210111_LC.e239eba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05049C_2_C_20210111_LC.png
// module id = Q+i8
// module chunks = 0